export default __webpack_public_path__ + "static/media/img1.127a003a.png";